package com.macrofocus.common.crossplatform

import com.macrofocus.common.concurrent.ExecutorService
import com.macrofocus.common.concurrent.Runtime
import com.macrofocus.common.timer.CPTimer
import com.macrofocus.common.timer.CPTimerListener
import kotlin.js.Date
import kotlin.reflect.KClass

actual class CPHelper {
    val visualizationExecutorService: ExecutorService? by lazy { newFixedThreadPool("VisualizationExecutorService", 0, Runtime.getRuntime().availableProcessors()) }

    actual companion object {
        actual val instance = CPHelper()
    }

    actual fun visualizationExecutorService(): ExecutorService? {
        return visualizationExecutorService
    }

    actual fun newFixedThreadPool(
        name: String,
        corePoolSize: Int,
        maximumPoolSize: Int
    ): ExecutorService? {
        return ExecutorService()
    }

    actual fun createTimer(
        name: String,
        delay: Int,
        postponing: Boolean
    ): CPTimer {
        return GWTTimer(name, delay, postponing)
    }

    actual fun createTimer(
        name: String,
        delay: Int,
        postponing: Boolean,
        timerListener: CPTimerListener
    ): CPTimer {
        val timer = createTimer(name, delay, postponing)
        timer.addTimerListener(timerListener)
        return timer
    }

    /**
     * Causes the currently executing thread to sleep (temporarily cease
     * execution) for the specified number of milliseconds, subject to
     * the precision and accuracy of system timers and schedulers. The thread
     * does not lose ownership of any monitors.
     *
     * @param  millis
     * the length of time to sleep in milliseconds
     *
     * @throws  IllegalArgumentException
     * if the value of `millis` is negative
     *
     * @throws  InterruptedException
     * if any thread has interrupted the current thread. The
     * *interrupted status* of the current thread is
     * cleared when this exception is thrown.
     */
    actual fun sleep(millis: Long) {
    }

    /** Without reflection: the same classes, Any, and the numbers for Number. */
    actual fun isAssignableFrom(a: KClass<*>, b: KClass<*>): Boolean = isAssignableWithoutReflection(a, b)

    actual fun isNumericType(cl: KClass<*>): Boolean {
        return cl != null && (isAssignableFrom(Number::class, cl)
                || cl == Double::class || cl == Int::class || cl == Float::class || cl == Short::class || cl == Long::class)
    }

    /** The dates are [kotlin.time.Instant]s. */
    actual fun isTemporalType(cl: KClass<*>): Boolean = isInstantType(cl)

    actual fun isTemporalValue(value: Any?): Boolean = isInstant(value)

    /** The milliseconds since the epoch of a date. */
    actual fun doubleTemporalValue(value: Any?): Double = instantMillis(value)


    actual fun isVisualType(cl: KClass<*>): Boolean {
        return false
    }

    actual fun isArray(cl: KClass<*>): Boolean {
        return Array::class == cl
    }

    actual val isMac: Boolean = false

    /** Current UNIX time in millis */
    actual val currentTimeMillis: Long
        get() = Date.now().toLong()
}